import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { UserSessionService } from 'src/app/services/usersession.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
    private userSessionService: UserSessionService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isLoggedIn = localStorage.getItem('isLoggedin');
    const isBCLoggedIn = localStorage.getItem('isBCLoggedin');
    if (isLoggedIn) {
      if (state.url === '/dashboard') {
        return true;
      }
    } else if (isBCLoggedIn) {
      this.router.navigate(['/bc_card']);
      return true;
    } else {
      this.router.navigate(['/auth']);
      return false;
    }
    this.router.navigate(['/auth']);
    return false;
  }
}
